import { Row, Col } from 'react-bootstrap';
import moment from 'moment';
import KPICard from '../../../components/FFDA/Reports/Simplified/KPICard';
import CallVolumeCard from '../../../components/FFDA/Reports/Simplified/CallVolumeCard';
import FormatedLine from '../../../components/FFDA/Reports/Detailed/FormatedLine';
import FormatedPercent from '../../../components/FFDA/Reports/Detailed/FormatedPercent';
import './DashboardSimplified.scss';

const monthFormat = "MM-D-YYYY ";
const monthFormat2 = "MMMM-YYYY ";

const DashboardSimplified = ({
    kpiData,
    financialSummaryData
}) => {
    let data = {};
    for (const [key, value] of Object.entries({...kpiData, ...financialSummaryData})) {
        data[key.toUpperCase()] = value;
    }

    // ---------------- KPI ----------------
    // Number of calls
    let KPI_numberOfCallsPeriod = data.TOTAL_CALLS_BURIAL_MONTHLY + data.TOTAL_CALLS_CREMATION_MONTHLY;
    let KPI_numberOfCallsYTD = data.TOTAL_CALLS_YTD;
    let KPI_numberOfCallsPriorPeriod = data.TOTAL_BURIAL_PRIOR_YEAR_SAME_MONTH + data.TOTAL_CREMATION_PRIOR_YEAR_SAME_MONTH;
    let KPI_numberOfCallsPriorYTD = data.TOTAL_CALLS_PRIOR_YTD;
    let KPI_numberOfCallsVariance = Math.round(KPI_numberOfCallsYTD - KPI_numberOfCallsPriorYTD);
    let KPI_numberOfCallsPercent = Math.round(KPI_numberOfCallsVariance / KPI_numberOfCallsPriorYTD * 100);

    // Total Gross Revenue
    let KPI_totalGrossRevenuePeriod = data.OPERATING_INCOME_BURIAL_THIS_MONTH + data.OPERATING_INCOME_CREMATION_THIS_MONTH;
    let KPI_totalGrossRevenueYTD = data.OPERATING_INCOME_TOTAL;
    let KPI_totalGrossRevenuePriorPeriod = data.OPERATING_INCOME_TOTAL_PRIOR_MONTH;
    let KPI_totalGrossRevenuePriorYTD = data.OPERATING_INCOME_TOTAL_PRIOR;
    let KPI_totalGrossRevenueVariance = Math.round(KPI_totalGrossRevenueYTD - KPI_totalGrossRevenuePriorYTD);

    let KPI_totalGrossRevenuePercent = Math.round((KPI_totalGrossRevenueVariance / KPI_totalGrossRevenuePriorYTD) * 100);
    if (KPI_totalGrossRevenueVariance > 0 && KPI_totalGrossRevenuePercent < 0) {
        KPI_totalGrossRevenuePercent *= -1;
    }

    // Total Gross Profit
    let KPI_totalCostOfGoodSoldPeriod = data.GROSS_PROFIT_TOTAL_THIS_MONTH;
    let KPI_totalCostOfGoodSoldYTD = data.GROSS_PROFIT_TOTAL;
    let KPI_totalCostOfGoodSoldPriorPeriod = data.GROSS_PROFIT_TOTAL_PRIOR_MONTH;
    let KPI_totalCostOfGoodSoldPriorYTD = data.GROSS_PROFIT_TOTAL_PRIOR;
    let KPI_totalCostOfGoodSoldVariance = Math.round(KPI_totalCostOfGoodSoldYTD - KPI_totalCostOfGoodSoldPriorYTD);

    let KPI_totalCostOfGoodSoldPercent = Math.round((KPI_totalCostOfGoodSoldVariance / KPI_totalCostOfGoodSoldPriorYTD) * 100);
    if (KPI_totalCostOfGoodSoldVariance > 0 && KPI_totalCostOfGoodSoldPercent < 0) {
        KPI_totalCostOfGoodSoldPercent *= -1;
    }

    // Total Net Profit
    let KPI_totalNetProfilPeriod = data.MONTHLY_NET_PROFIT_LOSS;
    let KPI_totalNetProfilYTD = data.NET_PROFIT_OR_LOSS_TOTAL;
    let KPI_totalNetProfilPriorPeriod = data.NET_PROFIT_OR_LOSS_PRIOR_MONTH;
    let KPI_totalNetProfilPriorYTD = data.PRIOR_NET_PROFIT_LOSS;
    let KPI_totalNetProfilVariance = Math.round(KPI_totalNetProfilYTD - KPI_totalNetProfilPriorYTD);

    let KPI_totalNetProfilPercent = Math.round((KPI_totalNetProfilVariance / KPI_totalNetProfilPriorYTD) * 100);
    if (KPI_totalNetProfilVariance > 0 && KPI_totalNetProfilPercent < 0) {
        KPI_totalNetProfilPercent *= -1;
    }

    // ---------------- Call Volume ----------------
    // Total Burial
    let CallVolume_totalBurialMonthly = data.TOTAL_CALLS_BURIAL_MONTHLY;
    let CallVolume_totalBurialYTD = data.TOTAL_BURIAL_YTD;
    let CallVolume_totalBurialPriorYearMonth = data.TOTAL_BURIAL_PRIOR_YEAR_SAME_MONTH;
    let CallVolume_totalBurialPriorYearYTD = data.TOTAL_BURIAL_PRIOR_YTD;
    let CallVolume_totalBurialMonthlyVariance = Math.round(CallVolume_totalBurialMonthly - CallVolume_totalBurialPriorYearMonth);
    let CallVolume_totalBurialYTDVariance = Math.round(CallVolume_totalBurialYTD - CallVolume_totalBurialPriorYearYTD);

    let CallVolume_totalBurialMonthlyPercent = ((CallVolume_totalBurialMonthlyVariance / CallVolume_totalBurialPriorYearMonth) * 100);
    if (CallVolume_totalBurialMonthlyVariance > 0 && CallVolume_totalBurialMonthlyPercent < 0) {
        CallVolume_totalBurialMonthlyPercent *= -1;
    }
    let CallVolume_totalBurialYTDPercent = ((CallVolume_totalBurialYTDVariance / CallVolume_totalBurialPriorYearYTD) * 100);
    if (CallVolume_totalBurialYTDVariance > 0 && CallVolume_totalBurialYTDPercent < 0) {
        CallVolume_totalBurialYTDPercent *= -1;
    }

    // Total Cremation
    let CallVolume_totalCremationMonthly = data.TOTAL_CALLS_CREMATION_MONTHLY;
    let CallVolume_totalCremationYTD = data.TOTAL_CREMATION_YTD;
    let CallVolume_totalCremationPriorYearMonth = data.TOTAL_CREMATION_PRIOR_YEAR_SAME_MONTH;
    let CallVolume_totalCremationPriorYearYTD = data.TOTAL_CREMATION_PRIOR_YTD;
    let CallVolume_totalCremationMonthlyVariance = Math.round(CallVolume_totalCremationMonthly - CallVolume_totalCremationPriorYearMonth);
    let CallVolume_totalCremationYTDVariance = Math.round(CallVolume_totalCremationYTD - CallVolume_totalCremationPriorYearYTD);

    let CallVolume_totalCremationMonthlyPercent = Math.round((CallVolume_totalCremationMonthlyVariance / CallVolume_totalCremationPriorYearMonth) * 100);
    if (CallVolume_totalCremationMonthlyVariance > 0 && CallVolume_totalCremationMonthlyPercent < 0) {
        CallVolume_totalCremationMonthlyPercent *= -1;
    }
    let CallVolume_totalCremationYTDPercent = Math.round((CallVolume_totalCremationYTDVariance / CallVolume_totalCremationPriorYearYTD) * 100);
    if (CallVolume_totalCremationYTDVariance > 0 && CallVolume_totalCremationYTDPercent < 0) {
        CallVolume_totalCremationYTDPercent *= -1;
    }

    // Total Call Volume
    let CallVolume_totalCallVolumeMonthly = CallVolume_totalBurialMonthly + CallVolume_totalCremationMonthly;
    let CallVolume_totalCallVolumeYTD = CallVolume_totalBurialYTD + CallVolume_totalCremationYTD;
    let CallVolume_totalCallVolumePriorYearMonth = CallVolume_totalBurialPriorYearMonth + CallVolume_totalCremationPriorYearMonth;
    let CallVolume_totalCallVolumePriorYearYTD = CallVolume_totalBurialPriorYearYTD + CallVolume_totalCremationPriorYearYTD;
    let CallVolume_totalCallVolumeMonthlyVariance = Math.round(CallVolume_totalCallVolumeMonthly - CallVolume_totalCallVolumePriorYearMonth);
    let CallVolume_totalCallVolumeYTDVariance = Math.round(CallVolume_totalCallVolumeYTD - CallVolume_totalCallVolumePriorYearYTD);

    let CallVolume_totalCallVolumeMonthlyPercent = ((CallVolume_totalCallVolumeMonthlyVariance / CallVolume_totalCallVolumePriorYearMonth) * 100);
    if (CallVolume_totalCallVolumeMonthlyVariance > 0 && CallVolume_totalCallVolumeMonthlyPercent < 0) {
        CallVolume_totalCallVolumeMonthlyPercent *= -1;
    }
    let CallVolume_totalCallVolumeYTDPercent = ((CallVolume_totalCallVolumeYTDVariance / CallVolume_totalCallVolumePriorYearYTD) * 100);
    if (CallVolume_totalCallVolumeYTDVariance > 0 && CallVolume_totalCallVolumeYTDPercent < 0) {
        CallVolume_totalCallVolumeYTDPercent *= -1;
    }

    return (
        <div className='dashboard-simplified-container'>
            <Row>
                <Col md={12} className="periodTitles">
                    <Row className="content d-flex smallFont">
                        <Col md={12} className="oneItem my-1">
                            Month: <span className="smallTitle smallDate">{moment(String(data.END_REPORT_CYCLE)).format(monthFormat2)}</span>
                        </Col>
                        <Col md={12} className="oneItem my-1">
                            YTD:
                            <div className='smallDate mr-auto'>
                                <span>From <span className="smallTitle me-1">{moment(String(data.START_REPORT_CYCLE)).format(monthFormat)}</span></span>
                                <span>To <span className="smallTitle">{moment(String(data.END_REPORT_CYCLE)).endOf('month').format(monthFormat)}</span></span>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <div className='my-1'>
                <div className="bigTitle d-flex justify-content-center align-content-center">
                    <div className="d-flex flex-wrap content justify-content-center align-content-center">KPIs</div>
                </div>
                <KPICard 
                    title={'Number of calls'}
                    period={KPI_numberOfCallsPeriod}
                    priorPeriod={KPI_numberOfCallsPriorPeriod}
                    year={KPI_numberOfCallsYTD}
                    priorYear={KPI_numberOfCallsPriorYTD}
                    varianceRaw=<FormatedLine type="percentage-mobile" content={KPI_numberOfCallsVariance} />
                    variancePercentage=<FormatedPercent type="mobile" content={KPI_numberOfCallsPercent} />
                />
                <KPICard 
                    title={'Total Revenue'}
                    period=<FormatedLine type="money" content={KPI_totalGrossRevenuePeriod} />
                    priorPeriod=<FormatedLine type="money" content={KPI_totalGrossRevenuePriorPeriod} />
                    year=<FormatedLine type="money" content={KPI_totalGrossRevenueYTD} />
                    priorYear=<FormatedLine type="money" content={KPI_totalGrossRevenuePriorYTD} />
                    varianceRaw=<FormatedLine type="money-mobile" content={KPI_totalGrossRevenueVariance} />
                    variancePercentage=<FormatedPercent type="mobile" content={KPI_totalGrossRevenuePercent} />
                />
                <KPICard 
                    title={'Total Gross Profit'}
                    period=<FormatedLine type="money" content={KPI_totalCostOfGoodSoldPeriod} />
                    priorPeriod=<FormatedLine type="money" content={KPI_totalCostOfGoodSoldPriorPeriod} />
                    year=<FormatedLine type="money" content={KPI_totalCostOfGoodSoldYTD} />
                    priorYear=<FormatedLine type="money" content={KPI_totalCostOfGoodSoldPriorYTD} />
                    varianceRaw=<FormatedLine type="money-mobile" content={KPI_totalCostOfGoodSoldVariance} />
                    variancePercentage=<FormatedPercent type="mobile" content={KPI_totalCostOfGoodSoldPercent} />
                />
                <KPICard 
                    title={'Net Profit Or Loss'}
                    period=<FormatedLine type="money" content={KPI_totalNetProfilPeriod} />
                    priorPeriod=<FormatedLine type="money" content={KPI_totalNetProfilPriorPeriod} />
                    year=<FormatedLine type="money" content={KPI_totalNetProfilYTD} />
                    priorYear=<FormatedLine type="money" content={KPI_totalNetProfilPriorYTD} />
                    varianceRaw=<FormatedLine type="money-mobile" content={KPI_totalNetProfilVariance} />
                    variancePercentage=<FormatedPercent type="mobile" content={KPI_totalNetProfilPercent} />
                />
            </div>

            <div className='my-1'>
                <div className="bigTitle d-flex justify-content-center align-content-center">
                    <div className="d-flex flex-wrap content justify-content-center align-content-center">Call Volume</div>
                </div>
                <CallVolumeCard
                    title={'Total Burial'}
                    month=<FormatedLine content={CallVolume_totalBurialMonthly} />
                    priorMonth=<FormatedLine content={CallVolume_totalBurialPriorYearMonth} />
                    year=<FormatedLine content={CallVolume_totalBurialYTD} />
                    priorYear=<FormatedLine content={CallVolume_totalBurialPriorYearYTD} />
                    percentagePeriod=<FormatedPercent type="mobile" content={CallVolume_totalBurialMonthlyPercent} />
                    percentageYTD=<FormatedPercent type="mobile" content={CallVolume_totalBurialYTDPercent} />
                />
                <CallVolumeCard
                    title={'Total Cremation'}
                    month=<FormatedLine content={CallVolume_totalCremationMonthly} />
                    priorMonth=<FormatedLine content={CallVolume_totalCremationPriorYearMonth} />
                    year=<FormatedLine content={CallVolume_totalCremationYTD} />
                    priorYear=<FormatedLine content={CallVolume_totalCremationPriorYearYTD} />
                    percentagePeriod=<FormatedPercent type="mobile" content={CallVolume_totalCremationMonthlyPercent} />
                    percentageYTD=<FormatedPercent type="mobile" content={CallVolume_totalCremationYTDPercent} />
                />
                <CallVolumeCard
                    title={'Total Call Volume'}
                    month=<FormatedLine content={CallVolume_totalCallVolumeMonthly} />
                    priorMonth=<FormatedLine content={CallVolume_totalCallVolumePriorYearMonth} />
                    year=<FormatedLine content={CallVolume_totalCallVolumeYTD} />
                    priorYear=<FormatedLine content={CallVolume_totalCallVolumePriorYearYTD} />
                    percentagePeriod=<FormatedPercent type="mobile" content={CallVolume_totalCallVolumeMonthlyPercent} />
                    percentageYTD=<FormatedPercent type="mobile" content={CallVolume_totalCallVolumeYTDPercent} />
                />
            </div>
        </div>
    );
}

export default DashboardSimplified;
